module.exports = __webpack_public_path__ + "img/09.b03f06dd.png";